import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-primary/10" data-id="element-19" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-20" data-mp="22divinsibn62">
        <div className="text-center mb-16" data-id="element-21" data-mp="1ydi84dnfk1mv">
          <p className="text-secondary font-bold tracking-widest uppercase mb-2" data-id="element-22" data-mp="1yet965phqvaa">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-bold uppercase text-primary" data-id="element-23" data-mp="15q5itvpvxfpv">
            🎁 <span className="text-secondary" data-id="element-24" data-mp="1jhajn14zoe1s">5 Professional Bonus Guides</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-25" data-mp="1epsj2e6vofhc">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-primary/15 rounded-xl p-8 shadow-sm shadow-primary/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-26" data-mp="qzohsdh5wrti" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-primary text-accent px-4 py-2 rounded-bl-xl rounded-tr-xl font-bold text-sm" data-id="element-27" data-mp="2oh8y6sk3gxeb">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-surface border border-accent rounded-lg flex items-center justify-center text-secondary mb-4" data-id="element-28" data-mp="1vrs9a4vonymu">
                <Gift size={24} data-id="element-29" data-mp="20ptscpt3zxyb" />
              </div>
              <h3 className="text-xl font-display font-bold mb-2 pr-28 text-primary" data-id="element-30" data-mp="25q83whtx5q13">{bonus.title}</h3>
              <p className="text-secondary text-sm italic mb-4 border-l-2 border-accent pl-4" data-id="element-31" data-mp="3c6tro5dvjd1u">
                {bonus.subtitle}
              </p>
              <p className="text-body text-sm mb-4 leading-relaxed" data-id="element-32" data-mp="3h43hhm56dqq7">{bonus.intro}</p>
              <p className="text-primary font-semibold text-sm mb-3" data-id="element-33" data-mp="1h23wpjvgnrbw">{bonus.bulletsLabel}</p>
              <ul className={`mb-6 flex-grow ${bonus.bullets.length > 10 ? `grid sm:grid-cols-2 ${index === 4 ? 'md:grid-cols-3' : ''} gap-x-4 gap-y-2 content-start` : 'space-y-2'}`} data-id="element-34" data-mp="1c396vxz2t2ia">
                {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-35" data-mp="yajhrko93hgy">
                    <CheckCircle2 size={16} className="text-secondary shrink-0 mt-0.5" data-id="element-36" data-mp="tfdxeqahyauz" />
                    <span className="text-body text-sm" data-id="element-37" data-mp="1760y2nztiatp">{bullet}</span>
                  </li>)}
              </ul>
              <div className="mt-auto pt-4 border-t border-primary/10" data-id="element-38" data-mp="12ceh4jmmfks3">
                {bonus.closingLabel && <p className="text-body text-sm mb-2" data-id="element-39" data-mp="anbcv3uqiafg">{bonus.closingLabel}</p>}
                <p className={bonus.closingLabel ? 'text-white font-display font-bold tracking-wide text-sm bg-primary rounded-md px-3 py-2' : 'text-primary font-semibold text-sm italic'} data-id="element-40" data-mp="alidm9mgashh">
                  {bonus.closing}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}